import CodeMirror from 'codemirror';
import { createSpanReplacementNode, createWarningSpanReplacementNode, matchTokenType } from '../markers/utils';
import { IPromptMessages, ICustomProperty } from '../index.d';
import { getStringTokenValue } from '../utils/codemirror';


// 自定义属性（主体属性、时机属性）替换
export function replaceCustomProperty(
    editor: CodeMirror.Editor,
    tokens: CodeMirror.Token[],
    idx: number,
    customProperties: ICustomProperty[],
    promptMessages: IPromptMessages
) {
    const token = tokens[idx];

    if (matchTokenType(token, 'custom-property-id')) {
        const line = token.state.line;

        const startPos = { line, ch: token.start };
        const endPos = { line, ch: token.end };

        const propertyId = Number(getStringTokenValue(token.string));
        const customProperty = customProperties.find(item => {
            return item.id === propertyId;
        }) || { id: undefined, name: promptMessages.invalidCustomProperty || 'Invalid Property', disabled: true };

        const replacementNode = !customProperty.disabled ?
            createSpanReplacementNode(customProperty.name, 'cm-custom-property-id') :
            createWarningSpanReplacementNode(
                customProperty.name,
                'cm-custom-property-id',
                customProperty.id ? promptMessages.disabledCustomPropertyTooltip : promptMessages.invalidCustomPropertyTooltip
            );

        editor.getDoc().markText(startPos, endPos, {
            replacedWith: replacementNode
        });
        return 1;
    }
    return 0;
}
